const ModalStyle = {
  style: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    overflow: "auto",
  },

  header: {
    textAlign: "center",
    backgroundColor: "#F9BA3E",
    padding: "1rem",
    borderRadius: "30px",
    position: "relative",
    zIndex: "1",
  },

  body: {
    position: "relative",
    zIndex: "0",
    marginTop: "-30px",
    backgroundColor: "white",
    padding: "2rem 2rem 2rem 2rem",
    borderRadius: "30px",
  },

  boton: {
    background: "#ffffff",
    border: "0.01px solid #888888",
    boxSizing: "border-box",
    borderRadius: "19px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    fontFamily: "Rambla-Bold",
    color: "black",
    textTransform: "none",
    fontSize: "1rem",
    width: "150px",
  },

  botonDisabled: {
    background: "#ffffff",
    opacity: "0.3",
    border: "0.01px solid #888888",
    boxSizing: "border-box",
    borderRadius: "19px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    fontFamily: "Rambla-Bold",
    color: "black",
    textTransform: "none",
    fontSize: "1rem",
    width: "150px",
  },

  botonBig: {
    background: "#ffffff",
    border: "0.01px solid #888888",
    boxSizing: "border-box",
    borderRadius: "19px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    fontFamily: "Rambla-Bold",
    color: "black",
    textTransform: "none",
    fontSize: "1rem",
    padding: "0 1rem",
  },
  botonBigDisabled: {
    background: "#ffffff",
    opacity: "0.3",
    border: "0.01px solid #888888",
    boxSizing: "border-box",
    borderRadius: "19px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    fontFamily: "Rambla-Bold",
    color: "black",
    textTransform: "none",
    fontSize: "1rem",
    padding: "0 1rem",
  },
};

export default ModalStyle;
